import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['close', 'submenu', 'submenuItem[]', 'circle'],
    emits: ['open'],
    options: {
      depth: {
        default: 0,
        type: Number,
      },
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.open = false;
  }

  /**
   * Click on submenu
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onSubmenuItemMouseenter({ target }) {
    const { x, y } = target.dataset;

    if (this.$refs.circle && x && y) {
      this.$refs.circle.style.opacity = 100;
      this.$refs.circle.style.left = `${x}px`;
      this.$refs.circle.style.top = `${y}px`;
    }
  }

  /**
   * Click on item which has submenu
   * @returns {void}
   */
  onClick() {
    this.openSubmenu();
  }

  /**
   * Close menu item
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onCloseClick({ event }) {
    event.stopPropagation();
    this.closeSubmenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openSubmenu() {
    if (this.open) return;

    this.$refs.submenu.classList.add('submenu--active');
    this.$emit('open');
    this.open = true;
  }

  /**
   * Close menu nothing more
   * @returns {void}
   */
  closeSubmenu() {
    this.$refs.submenu.classList.remove('submenu--active');
    this.open = false;
    this.$refs.circle.style.opacity = 0;
  }
}
